
import { Routes, Route } from 'react-router-dom'
import { Layout } from 'frame'
import { List, DrillDown } from './components'

export const ModuleRoutes = () => (
  <Layout>
    <List />
    <Routes>
      <Route path=":id/*" element={<DrillDown />} />
    </Routes>
  </Layout>
)

export default ModuleRoutes
